import type { AsyncThunkApiConfig } from '@/store'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

type Result = uui.domain.actions.rpc.route.ConflictVehicleSettingsActionResult['result']

type Args = {
  buildDates: string[]
}

export const conflictVehicleSettings = createAsyncThunk<
  Result,
  Args,
  AsyncThunkApiConfig<RejectError>
>('domain/route/conflictVehicleSettings', async ({ buildDates }, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/route/conflictVehicleSettings', {
      category: 'rpc',
      type: 'rpc/route/conflictVehicleSettings',
      payload: { buildDates },
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {conflictVehicleSettings}`,
      { tags: ['rpc', 'route'], info: { buildDates, error } },
      'error',
    )
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: 'conflictVehicleSettings failed',
      error: error instanceof Error ? error : undefined,
    })
  }
})
